export class PsiData {
    currentUser: any = {};
    messages: any = null;
    search: any = {};
    selectedAccount: any = {};
    selectedPolicy: any = {};
    selectedClaim: any = {};
    impersonatedBy:any = null;
    endorsement:any=null;
    submission:any = null;
}
